import { Component, OnInit, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { DialogService, TabulatorService } from '@nrwl/common-lib';
import { CartPickerTableComponent } from './cart-picker-table/cart-picker-table.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddUnmanagedDeviceComponent } from '@nrwl/datasource-management';
@Component({
  selector: 'nrwl-cart-items-picker',
  templateUrl: './cart-items-picker.component.html',
  styleUrls: ['./cart-items-picker.component.scss']
})
export class CartItemsPickerComponent implements OnInit {
  @ViewChild(CartPickerTableComponent) pickerComp: CartPickerTableComponent;
  @Input() tableData;
  @Input() singleSelection;
  @Input() persistenceID;
  @Input() cartView = false;
  @Input() cartItems;
  @Input() transformationString;
  @Input() hidingData;
  @Input() selectionLimit;
  @Input() childRows;
  @Input() pageConfigurations;
  twampmanagedDevices;
  //eslint-disable-next-line
  @Output() closeModal?: EventEmitter<any> = new EventEmitter();
  displayCartPage: boolean;
  constructor(
    private dialogService: DialogService,
    private tabulatorService: TabulatorService,
    private dialog: MatDialog
  ) {
    this.displayCartPage = false;
    this.dialog = dialog;
  }

  ngOnInit(): void {
    this.displayCartPage = this.cartItems && this.cartItems.length > 0;
    if (this.displayCartPage) {
      this.cartItems.forEach(item => (item.removed = false));
    }
  }

  onSave(): void {
    let data = [];
    if (!this.cartView) {
      data = this.pickerComp?.deviceTable?.selection ?? [];
    } else {
      this.cartItems = this.cartItems.filter(item => !item['removed'] && !item['notAvailed']);
      data = this.cartItems;
    }
    if (this.hasDuplicateIpAddress(data)) {
      this.dialogService.showInfo(
        'information',
        'body',
        'Cannot add endpoints with duplicate ipaddress',
        'Error - Duplicate IP Address'
      );
      return;
    }
    this.clearCardTabulatorCache();
    this.closeModal.emit(data);
  }

  clearCardTabulatorCache(): void {
    const clearItems = [
      'tabulator-cart-table-group',
      'tabulator-cart-table-filter',
      'tabulator-cart-table-sort',
      'tabulator-cart-table-page'
    ];
    clearItems.forEach(item => localStorage.setItem(item, null));
  }

  disableSave(): boolean {
    if (!this.cartView) {
      return (
        !this.pickerComp ||
        !this.pickerComp.deviceTable ||
        !this.pickerComp.deviceTable.selection ||
        (this.pickerComp &&
          this.pickerComp.deviceTable &&
          this.pickerComp.deviceTable.selection &&
          this.pickerComp.deviceTable.selection.length === 0)
      );
    }
  }
  disableCart(): boolean {
    return !this.cartItems || (this.cartItems && this.getCartCount() === 0);
  }
  openCartPage(): void {
    this.displayCartPage = true;
  }
  openPickerView(): void {
    this.cartItems = this.cartItems.filter(item => !item?.removed && !item?.notAvailed);
    this.displayCartPage = false;
  }
  getCartCount(): number {
    return this.cartItems.filter(item => !item?.removed && !item?.notAvailed).length;
  }
  //eslint-disable-next-line
  updateCartItems(items: any): void {
    this.cartItems = items;
  }

  addUnmanagedDevice(): void {
    const dialogRef = this.dialog.open(AddUnmanagedDeviceComponent, {
      width: '70rem',
      height: '71rem',
      disableClose: true,
      data: {
        showLoopbackDevicesTab: false
      }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response !== '') {
        this.tableData.next([...this.tableData['_value'], ...response.newTableRow]);
        this.tabulatorService?.addToCartClicked?.next(response.newCart);
      }
    });
  }

  showAlertPopup(): void {
    if (this.getCartCount() !== 0) {
      const params = {
        id: 'closeSpokeSelction',
        callBackService: this,
        callBackFuntion: () => {
          this.closeModal.emit(null);
        },
        cancelCallback: () => {
          return;
        }
      };
      this.dialogService.showDialog('confirm', 'body', params);
    } else {
      this.closeModal.emit(null);
    }
  }
  disableAddItems(): boolean {
    return !this.cartItems || (this.cartItems && this.getCartCount() === 0);
  }
  addtoCart(): void {
    const selectedDevice = this.pickerComp?.deviceTable?.selection ?? [];
    if (selectedDevice?.length) {
      selectedDevice.forEach(data => {
        if (data._children?.length) {
          data._children = data._children.some(child => child.filtered)
            ? data._children.filter(child => child.filtered)
            : data._children;
        }
      });
    }

    this.tabulatorService.addToCartClicked.next(selectedDevice);
  }

  //eslint-disable-next-line
  hasDuplicateIpAddress(selectedDevice: any): boolean {
    let selectedIpaddress = [];
    if (selectedDevice?.length) {
      selectedIpaddress = selectedDevice
        .map(item => {
          if (item.rowType === 'parent' && item._children?.length) {
            return item._children[0].ipAddress.label;
          } else {
            return item.ipAddress.label;
          }
        })
        .flat();
    }
    return new Set(selectedIpaddress).size !== selectedIpaddress.length;
  }
}
